import { AnimationMixer } from "three";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";
class AnimationController {
    animations;
    mixer;
    /**
     * A controller for an entitie's animations.
     * @param animations The animations to use for an entity.
     * @param target The 3D model to apply the animations to.
     */
    constructor(animations, target) {
        this.mixer = new AnimationMixer(target);
        this.animations = this.loadAnimations(animations);
    }
    /**
     * Load the given animations into the mixer.
     * @param animations The animations to load into the animation mixer.
     * @returns An object containing the the clip and action corresponding to each animation.
     */
    loadAnimations(animations) {
        const output = {};
        for (const [key, value] of Object.entries(animations)) {
            output[key] = this.loadAnimation(value);
        }
        return output;
    }
    /**
     * Load an animation into the animation mixer.
     * @param animation The animation loader to create an animation object from.
     * @returns The created animation object.
     */
    loadAnimation(animation) {
        const clip = clone(animation.getAsset).animations[0];
        const action = this.mixer.clipAction(clip);
        return {
            clip: clip,
            action: action,
        };
    }
    /**
     * Perform an update on the animation.
     * @param deltaTime The interval in seconds from the last frame to the current one.
     */
    update(deltaTime) {
        this.mixer.update(deltaTime);
    }
    get getAnimations() {
        return this.animations;
    }
}
export default AnimationController;
